export const initialState = {
  actionProcessing: false,
  startAmount: {},
  lastWinners: [],
};
